import { api } from './client';
import type { AuditReport, Env } from '../types';

export function runAudit(env: Env) {
  return api<AuditReport>(`/audit?env=${env}`);
}
